if (navigator.share) {
  const b = document.querySelector('#share-event-button');
  const { title } = b.dataset;
  const data = {
    title,
    url: location.href,
  };
  b.addEventListener('click', async () => {
    console.log(data);
    try {
      await navigator.share(data);
    } catch (e) {
      console.log(e);
    }
  });
  b.classList.remove('hidden');
}
